import styled from "styled-components/macro";

import {
  AddressMain,
  CityField,
  CountryField,
  FnrAddress,
  Line1,
  Line2,
  StateField,
  StreetField,
  ZipField,
} from "UI/FnrAddress";

import ExtendedFieldErrorMessage from "./ExtendedFieldErrorMessage";
import { Label, RequiredIcon } from "./styles";

const wrapperStyles = {
  border: "1px solid #e0e0e0",
};

export default function AddressField({
  value,
  onChange,
  field,
  error,
  accentColor = "inherit",
  labelColor = "#4c5464",
}) {
  //   const [address, setAddress] = useState(value || {});
  const { ID, icon, title, inputIsRequired, defaultCountryID } = field;

  const updateValue = (key, val) => {
    if (onChange) {
      let address = { ...value };
      address[key] = val;
      onChange(address);
    }
  };

  const { addr1, country, countryID, city, state, zip } = value;

  return (
    <div>
      <Label labelColor={labelColor}>
        {title}
        {inputIsRequired && <RequiredIcon />}
      </Label>
      <FnrAddress style={wrapperStyles}>
        <AddressMain>
          <StyledLine1 focusColor={accentColor}>
            <StreetWrapper focusColor={accentColor}>
              <StreetField
                value={addr1}
                onChange={(e) => updateValue("addr1", e.target.value)}
                label=""
                hideInternalFocusStyles={true}
                style={{
                  borderTopLeftRadius: "5px",
                  borderTopRightRadius: "5px",
                  padding: field?.allowChangeCountry
                    ? "6px 36px 6px 6px"
                    : "6px",
                }}
              />
            </StreetWrapper>

            {field?.allowChangeCountry && (
              <CountryWrapper focusColor={accentColor}>
                <CountryField
                  value={country || countryID || defaultCountryID}
                  onChange={(val) => updateValue("country", val)}
                  label=""
                  flagFontSize="20px"
                  showOpenIndicator={false}
                  hideInternalFocusStyles={true}
                  style={{
                    width: "max-content",
                    borderRight: "none",
                    padding: "0 4px",
                    borderRadius: "5px",
                  }}
                />
              </CountryWrapper>
            )}
          </StyledLine1>

          <Line2>
            <CityWrapper focusColor={accentColor}>
              <CityField
                value={city}
                onChange={(e) => updateValue("city", e.target.value)}
                label=""
                hideInternalFocusStyles={true}
              />
            </CityWrapper>
            <Wrapper focusColor={accentColor}>
              <StateField
                value={state}
                onChange={(val) => updateValue("state", val)}
                countryID={country || defaultCountryID}
                hideLabel={true}
                style={{ width: "80px" }}
              />
            </Wrapper>
            <ZipWrapper focusColor={accentColor}>
              <ZipField
                value={zip}
                onChange={(e) => updateValue("zip", e.target.value)}
                countryID={countryID || country}
                name=""
                hideInternalFocusStyles={true}
              />
            </ZipWrapper>
          </Line2>
        </AddressMain>
      </FnrAddress>
      {error ? (
        <ExtendedFieldErrorMessage>{error}</ExtendedFieldErrorMessage>
      ) : null}
    </div>
  );
}

const StyledLine1 = styled(Line1)`
  position: relative;
  padding: 0;
`;

const Wrapper = styled.div`
  &:focus-within {
    z-index: 9999;
    box-shadow: ${(props) => `0 0 0 2px ${props.focusColor}`};
  }
`;

const StreetWrapper = styled(Wrapper)`
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const CountryWrapper = styled(Wrapper)`
  border-radius: 5px;
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  width: max-content;
  border-right: none;
  border-radius: 5px;
`;

const CityWrapper = styled(Wrapper)`
  border-bottom-left-radius: 5px;
  flex: 1;
`;

const ZipWrapper = styled(Wrapper)`
  max-width: 130px;
  border-bottom-right-radius: 5px;
  display: flex;
  align-items: center;
`;
